import { AssessmentChartLabelToValueMap } from './AssessmentChartLabelToValueMap';

export const AssessmentUnchartedKeys: Array<
  keyof Pick<
    AssessmentChartLabelToValueMap,
    | 'assessmentResponseId'
    | 'assignee'
    | 'completedOrUpdatedBy'
    | 'epochCompletedOrUpdatedDate'
    | 'epochCreatedDate'
    | 'status'
    | 'riskLevel'
    | 'completedOrUpdatedByUserType'
    | 'completedOrUpdatedByUserAvatarSrc'
    | 'completedOrUpdatedByUserId'
  >
> = [
  'assessmentResponseId',
  'assignee',
  'completedOrUpdatedBy',
  'epochCreatedDate',
  'epochCompletedOrUpdatedDate',
  'status',
  'riskLevel',
  'completedOrUpdatedByUserType',
  'completedOrUpdatedByUserAvatarSrc',
  'completedOrUpdatedByUserId',
];
